<div class="titulo-receber-filter">
    <div class="titulo-receber-filter-quick">  
        <div class="titulo-receber-filter-quick-block titulo-receber-filter-quick-block-options">
            <div class="titulo-receber-filter-quick-block-data">
                <!-- Data de Vigência -->
                <div class="input-group">
                    <div class="input-group-prepend referencia-data-select">
                        <sgt-titulo-receber-referencia-data-select
                            [(idReferencia)]="filter.referenciaData"
                            (idReferenciaChange)="onChangeReferenciaData()"
                            [canSelectNull]="false">
                        </sgt-titulo-receber-referencia-data-select>
                    </div>

                    <sgt-datepicker 
                       [(ngModel)]="filter.dataInicioVigencia" 
                       [(startDate)]="filter.dataInicioVigenciaPeriodo"
                       [(endDate)]="filter.dataTerminoVigenciaPeriodo"
                       name="dataVigenciaFilter" 
                       id="dataVigenciaFilter"
                       #dataVigenciaFilter="ngModel" #dataVigenciaDatepicker [ngControl]="dataVigenciaFilter" 
                       [mode]="dataVigenciaDatepickerMode"
                       [showBtnCalendar]="false"
                       [withNavigation]="true"
                       [showPeriodicidadeDiaria]="true"
                       [showPeriodicidadeMensal]="true"
                       [showPeriodicidadeTrimestral]="true"
                       [showPeriodicidadeSemestral]="true"
                       [showPeriodicidadeAnual]="true"   
                       [showPeriodicidadePeriodo]="true"    
                       [showPeriodicidadeTodoPeriodo]="true"         
                       [(periodicidade)]="filter.periodicidadeVigencia"
                       [(mes)]="filter.mesVigencia"
                       [(trimestre)]="filter.trimestreVigencia"
                       [(semestre)]="filter.semestreVigencia"
                       [(ano)]="filter.anoVigencia"
                       (ngModelChange)="onChangeDataVigencia()"
                       (startDateChange)="onChangeDataInicioVigenciaPeriodo()"
                       (endDateChange)="onChangeDataTerminoVigenciaPeriodo()">
                   </sgt-datepicker> 
                </div>
            </div>

            <!-- Situações -->
            <div class="titulo-receber-filter-quick-block-options-multiselect-item">
                <sgt-titulo-receber-situacao-multiselect
                    [(situacoes)]="filter.situacoes"
                    (situacoesChange)="onChangeSituacoes()"
                    defaultTitle="Situações"
                    [disabled]="!(initialization.initialized | async)">
                </sgt-titulo-receber-situacao-multiselect>
            </div>   
            
            <!-- Representantes -->
            <div class="titulo-receber-filter-quick-block-options-multiselect-item" *ngIf="config?.isShowRepresentantes">
                <sgt-representante-multiselect
                    [(idsRepresentantes)]="filter.idsRepresentantes"
                    (idsRepresentantesChange)="onChangeRepresentantes()"
                    [(somenteAtivos)]="filter.somenteRepresentantesAtivos"
                    defaultTitle="Representantes"
                    [disabled]="!(initialization.initialized | async)">
                </sgt-representante-multiselect>                
            </div>    
            
            <!-- Classificações de Clientes -->
            <div class="titulo-receber-filter-quick-block-options-multiselect-item" *ngIf="config?.isShowClassificacoesClientes">
                <sgt-classificacao-tipo-multiselect
                    [(idsClassificacoes)]="filter.idsClassificacoesClientes"
                    (idsClassificacoesChange)="onChangeClassificacoesClientes()"
                    [(nullOption)]="filter.classificacaoClienteNull"
                    [showNullOption]="true"
                    [tipoClassificacaoCadastroCliente]="true"
                    [pullRight]="true"
                    defaultTitle="Segmentos de Clientes"
                    checked="Segmento de Cliente"
                    checkedPlural="Segmentos de Clientes"
                    [disabled]="!(initialization.initialized | async)">
                </sgt-classificacao-tipo-multiselect>
            </div>


            <div class="titulo-receber-filter-quick-block-options-filter-psq">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            Número
                        </span>
                    </div>
                    <input type="text" class="form-control" [(ngModel)]="filter.numeroErp"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Pesquisa pelo número do título...">
                </div>
            </div>        

            <div class="titulo-receber-filter-quick-block-options-btns">
                <div class="titulo-receber-filter-quick-block-options-btns">
                    <div class="btn-group">
                        <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                            [disabled]="!(initialization.initialized | async)">
                            <i class="fas fa-sync"></i>
                        </button>
                        <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                            [disabled]="!(initialization.initialized | async)">
                            <i class="fas fa-eraser" aria-hidden="true"></i>
                        </button>
        
                        
                        <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                            (click)="toggleCollapse()" title="Filtro avançado"
                            [disabled]="!(initialization.initialized | async)">
                            <ng-template [ngIf]="(initialization.initialized | async)">
                                <i class="fas fa-filter" aria-hidden="true"></i>
                                <i [class]="collapseIcon" aria-hidden="true"></i>
                            </ng-template>
                            <ng-template [ngIf]="!(initialization.initialized | async)">
                                <i class='fas fa-spinner fa-pulse'></i>
                            </ng-template>
                        </button>
                       
                    </div>  
                </div>
            </div>
        </div>
    </div>

    
    <div class="titulo-receber-filter-collapse" #filterCollapse>
        <div class="row" *ngIf="config?.isShowCliente">                      
            <div class="form-group col-12">
                <label for="pessoa" class="col-form-label">Cliente</label>
                <sgt-typeahead-cliente-pessoa [(ngModel)]="filter.pessoa" name="pessoa" id="pessoa"
                    #pessoa="ngModel" [ngControl]="pessoa"
                    (typeaheadChange)="onTypeaheadChangeCliente($event)">
                </sgt-typeahead-cliente-pessoa>                                  
            </div>
        </div>
        <div class="row" *ngIf="config?.isShowGerentes">
            <div class="form-group col-12">
                <label class="col-form-label">Gerentes</label>
                <sgt-usuario-gerente-multiselect
                    [(idsGerentes)]="filter.idsGerentes"
                    (idsGerentesChange)="onChangeGerentes()"
                    [somenteAtivos]="true"
                    defaultTitle="Gerentes">
                </sgt-usuario-gerente-multiselect>
            </div>
        </div>
        <div class="row" *ngIf="config?.isShowAtendentes">
            <div class="form-group col-12">
                <label class="col-form-label">Atendentes</label>
                <sgt-usuario-atendente-multiselect
                    [(idsAtendentes)]="filter.idsAtendentes"
                    (idsAtendentesChange)="onChangeAtendentes()"
                    [somenteAtivos]="true"
                    defaultTitle="Atendentes">
                </sgt-usuario-atendente-multiselect>
            </div>
        </div>
        <div class="row" *ngIf="configEmpresa?.possuiLocalFaturamento">
            <div class="form-group col-12">
                <label class="col-form-label">Locais de Faturamentos</label>
                <sgt-local-faturamento-multiselect
                    [(idsLocaisFaturamentos)]="filter.idsLocaisFaturamentos"
                    (idsLocaisFaturamentosChange)="onChangeLocaisFaturamentos()"
                    [dropup]="true">
                </sgt-local-faturamento-multiselect> 
            </div>             
        </div>              
    </div>
</div>